import { EDIT_TEMPLATE_URL } from '../config';

export const generateEditUrl = (data: { metaSiteId: string }) => {
  const { metaSiteId } = data;

  const editorUrl = new URL(EDIT_TEMPLATE_URL);
  editorUrl.searchParams.append('originTemplateId', metaSiteId);

  return editorUrl.href;
};
